module.exports = __webpack_public_path__ + "img/9791185871271.5a99ff70.jpg";